import React, { ComponentPropsWithoutRef, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { Select } from '../../Common/Select'

import { useGeAbsenceTypeListQuery } from './useAbsenceTypeQuery'

export const AbsenceTypeSelect = (
  props: Omit<ComponentPropsWithoutRef<typeof Select>, 'options'>,
) => {
  const { data, status } = useGeAbsenceTypeListQuery()

  const { t } = useTranslation()

  const options = useMemo(() => {
    if (status === 'success') {
      return data.list.flatMap(item => {
        const parentOption = {
          label: `${item.key.charAt(0).toUpperCase()}${item.key.slice(1)}`,
          value: item.uuid,
          isParentSection: true, // This option is a parent item
        }
        // If the item has no types, return the item itself
        if (item.types.length === 0) {
          return parentOption
        }
        // If the item has types, return the parent option followed by its types
        const typeOptions = item.types.map(type => ({
          label: t(`absence.${type.key}`),
          value: type.uuid,
          isParentSection: false,
          indent: 12,
          selected: type.key === 'personal_holiday',
        }))

        return [parentOption, ...typeOptions]
      })
    }
    return []
  }, [status, t, data])

  return <Select {...props} options={options} />
}
